import React from 'react'
import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import { AllModules } from "ag-grid-enterprise";
import ComFunction from "../components/ComFunction";
import AGFunction from "../components/AGFunction";
import MasterBase from "../components/MasterLayout";
import EntryBase from "../components/EntryBase";
import EntryGrid from "../components/EntryGrid";
import EntryImages from "../components/EntryImages";
import EntryFiles from "../components/EntryFiles";
import WashGrid from "../components/WashGrid";
import EntrySetting from "../components/EntrySetting";
import DataTree from "../components/DataTree";
import DropZone from "../components/DropZone";
import Headline from "../components/Headline";
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import {
    isEmpty, getglobaldata, initializedata, Getstorage, Savestorage, NumConv, DeepCopy, getWindowDimensions, setglobaldata,
    getformid, getcontroller, getsubkey, GetDesitRound, isEnabled
} from '../modules/appLibrary';
import { cfFileUpload, cfNewUploadFile, cfMargeUploadFiles } from '../modules/commodule';
import { setimagelist} from '../modules/imagedlgstore';
import { arrayMove } from 'react-sortable-hoc';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import Chip from '@material-ui/core/Chip';
import { styled } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import EntryLayout from '../components/EntryLayout';
import { changestatus, listtabs, entrytriggercall, readonly,reports} from '../modules/formstore';
import { setentrypanel, addentrylayout, setentrylayout, setentrystartup} from '../modules/toolpanelstore';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@material-ui/core/TextField';

const ListItem = styled('li')(({ theme }) => ({
    margin: theme.spacing(0.5),
    listStyle: 'none'
}));

//-----------------------------------------------------------------------------------------
// 暫定対応
// カラー、サイズの中止はListのみ
// Listからカラー、サイズ、製品タブを削除すると子テーブルで使用されている為エラーとなる
//-----------------------------------------------------------------------------------------
export const Instruction = props => {
    const inittag = [
        {
            value: '0',
            label: '本体',
        },
    ];
    const panelsdef = [];
    const G_id = {
        BASE: "0", IMAGE: "pic", SKU: "4", RAW1: "7", RAW2: "8", RAW3: "9",
        PROCESS: "10", COMP: "11", WASH: "12", ATTN: "13", DEME: "14", FILE: "file", ROW: "16"
    }
    const primarykeys = ["d_inst_code", "d_inst_color_key", "d_inst_size_key", "d_inst_sku_key", "d_inst_raw_key", "d_inst_proc_key", "d_inst_tag_key", "d_inst_comp_key","d_inst_attn_key", "d_inst_deme_key", "d_inst_wtag_key", "d_inst_row_key"];
    const formid = getformid("Instruction", props.location.search);
    const controller = getcontroller("Instruction", props.location.search);
    const subkey = getsubkey(props.location.search);
    const search = useLocation().search;

    const corpkey = useSelector(state => state.user.corpkey);
    const account = useSelector(state => state.user.account);
    const staff = useSelector(state => state.user.accctl);
    const warndescription = useSelector(state => state.form.warndiscription);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const themestyle = useSelector(state => state.form.themestyle);
    const imagelist = useSelector(state => state.imgdlg.images);

    const AGRef = useRef();
    const fnc = useRef();
    const EntrybodyRef = useRef(null);
    const apiRefraw1 = useRef({ grid: undefined, column: undefined });
    const apiRefraw2 = useRef({ grid: undefined, column: undefined });
    const apiRefraw3 = useRef({ grid: undefined, column: undefined });
    const apiRefproc = useRef({ grid: undefined, column: undefined });
    const apiRefcomp = useRef({ grid: undefined, column: undefined });
    const apiRefwash = useRef({ grid: undefined, column: undefined });
    const apiRefattn = useRef({ grid: undefined, column: undefined });
    const apiRefdeme = useRef({ grid: undefined, column: undefined });
    const apiRefrow = useRef({ grid: undefined, column: undefined });
    const apiRefsku = useRef({ grid: undefined, column: undefined });

    const menuinfo = useSelector(state => state.form.menuinfo);
    const formstatus = useSelector(state => state.form.status);
    const entrylock = useSelector(state => state.form.entryformlock);
    const [panel, setpanel] = useState(panelsdef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [columninfo, setcolumninfo] = useState(null);     //全カラム情報
    const [columns, setcolumns] = useState(null);
    const [edittingcode, setedittingcode] = useState(null);
    const [textfieldsall, settextfieldsall] = useState([]);
    const [textfields, settextfields] = useState([]);
    const [update, setUpdata] = useState(false);
    const [files, setfiles] = useState([]);
    const [tagno, settagno] = useState('0');
    const [taglist, settaglist] = useState(inittag);
    const [layoutlock, setlayoutlock] = useState(false);
    const [sectionclose, setsectionclose] = useState(false);
    const [isDragActive, setIsDragActive] = useState(false);

    const dispatch = useDispatch();
    const AGFunc = React.forwardRef(AGFunction);
    const ComFunc = React.forwardRef(ComFunction);
    const scrollRef = useRef(null);
    const AcceptNo = useRef({ no: "" });
    const locationstate = useRef(null);    //遷移State
    const reportsRef = useRef(null);

    //データ
    const entrydataRef = useRef(null);    
    const colordataRef = useRef(null);
    const sizedataRef = useRef(null);
    const skudataRef = useRef(null);
    const raw1dataRef = useRef(null);
    const raw2dataRef = useRef(null);
    const raw3dataRef = useRef(null);
    const procdataRef = useRef(null);
    const rowdataRef = useRef(null);
    const imageRef = useRef(null);
    const fileRef = useRef(null);         //ファイル  
    const compdataRef = useRef(null);
    const compbytagRef = useRef([]);
    const washdataRef = useRef(null);
    const washbytagRef = useRef([]);
    const attndataRef = useRef(null);
    const attnbytagRef = useRef([]);
    const demedataRef = useRef(null);
    const demebytagRef = useRef([]);

    //列情報
    const skucolRef = useRef(null);
    const raw1colRef = useRef(null);
    const raw2colRef = useRef(null);
    const raw3colRef = useRef(null);
    const proccolRef = useRef(null);
    const rowcolRef = useRef(null);
    const compcolRef = useRef(null);
    const washcolRef = useRef(null);
    const attncolRef = useRef(null);
    const demecolRef = useRef(null);
    const coldefRefs = [
        { id: G_id.SKU, ref: skucolRef, dataref: skudataRef, api: apiRefsku.current, table: "d_inst_sku" },
        { id: G_id.RAW1, ref: raw1colRef, dataref: raw1dataRef, api: apiRefraw1.current, table: "d_inst_raw:0" },
        { id: G_id.RAW2, ref: raw2colRef, dataref: raw2dataRef, api: apiRefraw2.current, table: "d_inst_raw:1" },
        { id: G_id.RAW3, ref: raw3colRef, dataref: raw3dataRef, api: apiRefraw3.current, table: "d_inst_raw:2" },
        { id: G_id.PROCESS, ref: proccolRef, dataref: procdataRef, api: apiRefproc.current, table:"d_inst_proc" },
        { id: G_id.ROW, ref: rowcolRef, dataref: rowdataRef, api: apiRefrow.current, table:"d_inst_row" },
        { id: G_id.COMP, ref: compcolRef, dataref: compdataRef, api: apiRefcomp.current, table:"d_inst_comp" },
        { id: G_id.WASH, ref: washcolRef, dataref: washdataRef, api: apiRefwash.current, table:"d_inst_wash" },
        { id: G_id.ATTN, ref: attncolRef, dataref: attndataRef, api: apiRefattn.current, table:"d_inst_deme" },
        { id: G_id.DEME, ref: demecolRef, dataref: demedataRef, api: apiRefdeme.current, table:"d_inst_row" }];

    function statusKey(id) {
        return formid + "entry_" + id;
    }
    function onDragEnter(e) {
        if (entrylock) return;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setIsDragActive(true);
        }
    };
    function FileDropClose() {
        setIsDragActive(false);
    }


    const actionurl = {
        "insert": "instruction/Insert",
         "update": "instruction/Update",
         "delete": "instruction/Delete",
         "saveas": "instruction/SaveAs",
        "storageadd": "instruction/AddStorage",
        "storagerowdel": "instruction/StorageRowdel",
         "upload": "instruction/Upload",
         "masonry": "instruction/Masonry",
    }

    const navmenu = [
        { status: "ENTRY FORM", menuid: "formupload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "ENTRY FORM", menuid: "sep" },
        { status: "ENTRY FORM", menuid: "datatree", icon: "account_tree", label: "Data Tree" },
        { status: "VIEW", menuid: "excel", icon: "file_download", label: "Excel", title: "現在のシート内容をExcelに出力します" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "upload", icon: "upload_file", label: "関連ファイルUpload", title: "関連ファイルをアップロードします" },
        { status: "VIEW", menuid: "sep" },
        { status: "VIEW", menuid: "listdatatree", icon: "account_tree", label: "Data Tree" },
    ]

    //動作抑止
    const suppressaction = [
        { type: "1", action: "INSERT" },
        { type: "2", action: "INSERT" }
    ];

    function rerender() {
        setUpdata(update ? false : true);
    }


    useEffect(() => {
        if (isEmpty(corpkey) || isEmpty(account)) return;
        //ListTabを取得
        fnc.current.postaxios('common/GetListTabs', { "panels": panelsdef, "controller": controller, "subkey": subkey },
            {
                onSuccess: function (data) {
                    setpanel(data.panels);
                    dispatch(reports(data.reports));
                    dispatch(setentrypanel({
                        layouts: data.layouts, prelayout: data.prelayout,
                        initlayout: data.initlayout.length === 0 ? " " : data.initlayout,
                        fitColumn: data.fitColumn
                    }));
                    reportsRef.current = data.reports;
                    //SKU明細定義追加
                    let cols = [
                        { columnid: 'cancel', columnnm: '除外', datatype: "13" , type:"103", logpid:G_id.SKU},
                        { columnid: 'colorcd', columnnm: 'C/#', datatype: "0", type: "103", logpid: G_id.SKU, locked:true},
                        { columnid: 'colornm', columnnm: 'カラー', datatype: "0", type: "103", logpid: G_id.SKU, locked: true}
                    ];
                    data.colinfo = [...data.colinfo, ...cols];
                    setcolumninfo(data.colinfo);
                    data.columns = [...data.columns, ...cols];
                    setcolumns(data.columns);
                    let fields = data.colinfo.filter(e => e.logpid === G_id.BASE);
                    settextfieldsall(fields);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    //列情報初期化
                    for (let i = 0; i < coldefRefs.length; i++) {
                        coldefRefs[i].ref.current = null;
                    }
                    if (data.prelayout) {   //レイアウト復元
                        RestoreLayout(data.panels, fields);
                    }

                    //遷移state取得
                    let state = props.location.state;   //history.push
                    if (isEmpty(state) && !isEmpty(window.history.state)) {
                        if ("status" in window.history.state) {
                            //go back
                            state = window.history.state;
                        }
                    }
                    locationstate.current = state;
                    if (!isEmpty(state)) {
                        if ("code" in state) {
                            clearform();
                            dispatch(changestatus(state.code === "" ? "NEW FORM" : "ENTRY FORM"));
                        }
                    }
                    fnc.current.wait(false);
               }
            });
   }, []);

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isEmpty(menuinfo.ctrls)) return;
        setlayoutlock(menuinfo.ctrls.indexOf("LOCK2") !== -1);
        setsectionclose(menuinfo.ctrls.indexOf("SECCLOSE") !== -1); //セクションCLOSEボタン
    }, [menuinfo]);


    useEffect(() => {
        if (formstatus === "COPY FORM") {
            entrydataRef.current["d_inst_no"] = "";
            entrydataRef.current["d_inst_createac"] = "";
            entrydataRef.current["d_inst_createdate"] = "";
            entrydataRef.current["d_inst_updateac"] = "";
            entrydataRef.current["d_inst_update"] = "";
            rerender();
        }
        //基本情報編集制御
        let newfds = DeepCopy(textfields);
        let item = newfds.find(e => e.columnid === "d_inst_prodno");
        if (!isEmpty(item)) {
            item.locked = formstatus === "ENTRY FORM";
            settextfields(newfds);
        }
    }, [formstatus]);

    useEffect(() => {
        restoreScrollPos();
    }, [tagno,taglist]);



    //遷移state状態表示
    function callshow() {
        if (locationstate.current.code !== "") {
            Show(undefined, locationstate.current.code)
        } else {
            if (!isEmpty(locationstate.current.acceptno)) {
                clearform();
                if (entrydataRef.current === null) entrydataRef.current = {};
                entrydataRef.current["d_inst_prodno"] = locationstate.current.acceptno;
                AcceptAction(locationstate.current.acceptno,  true);
            }
        }
        locationstate.current = null;   //最初の１度のみ
    }

    function onFirstDataRendered(param, id) {
        if (id === G_id.RAW1) {
            apiRefraw1.current.grid = param.api;
            apiRefraw1.current.column = param.columnApi;
        }
        if (id === G_id.RAW2) {
            apiRefraw2.current.grid = param.api;
            apiRefraw2.current.column = param.columnApi;
        }
        if (id === G_id.RAW3) {
            apiRefraw3.current.grid = param.api;
            apiRefraw3.current.column = param.columnApi;
        }
        if (id === G_id.PROCESS) {
            apiRefproc.current.grid = param.api;
            apiRefproc.current.column = param.columnApi;
        }
        if (id === G_id.COMP) {
            apiRefcomp.current.grid = param.api;
            apiRefcomp.current.column = param.columnApi;
        }
        if (id === G_id.WASH) {
            apiRefwash.current.grid = param.api;
            apiRefwash.current.column = param.columnApi;
        }
        if (id === G_id.ATTN) {
            apiRefattn.current.grid = param.api;
            apiRefattn.current.column = param.columnApi;
        }
        if (id === G_id.DEME) {
            apiRefdeme.current.grid = param.api;
            apiRefdeme.current.column = param.columnApi;
        }
        if (id === G_id.ROW) {
            apiRefrow.current.grid = param.api;
            apiRefrow.current.column = param.columnApi;
        }
        if (!isEmpty(locationstate.current)) {
            let call = true;
            for (let i = 0; i < coldefRefs.length; i++) {
                if (EmptyPanel(coldefRefs[i].id)) continue;
                if (isEmpty(coldefRefs[i].api.grid)) {
                    call = false; break;
                }
            }
            //遷移表示
            if(call) callshow();
        }
    }
    function onGridReady(param, id) {
        if (id === G_id.SKU) {
            apiRefsku.current.grid = param.api;
            apiRefsku.current.column = param.columnApi;
        }
     }
    function Show(data, pushcode) {
        let code = "";
        if (data === undefined) {
            if (!isEmpty(pushcode)) {   //history.push
                code = pushcode;
                setedittingcode(code);
            } else {
                code = edittingcode;    //再表示
            }
        } else {
            setglobaldata("entryrowdata",data);
            if (data !== null) {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (data[primarykeys[i]]) {
                        code = data[primarykeys[i]]; break;
                    }
                }
            }
            setedittingcode(code);
        }
        if (isEmpty(columninfo) || isEmpty(columns)) return false;    //読み込み前

        clearform(code==="");
        //データ読み込み
        LoadData(code);
        return true;
    }

    function LoadData(code) {
        if (code === "") return;
        fnc.current.postaxios('instruction/GetData', { "code": code, "colinfo": columninfo, "controller": controller },
            {
                onSuccess: function (data) {
                    try {
                        if (code !== "") {
                            //ViewからのMyField値を引継ぎ
                            let row = getglobaldata("entryrowdata");
                            if (!isEmpty(row)) {
                                if ("d_inst_memo" in row) data.data.d_inst_memo = row.d_inst_memo;
                                if ("d_inst_sticky" in row) data.data.d_inst_sticky = row.d_inst_sticky;
                                if ("d_inst_mytags" in row) data.data.d_inst_mytags = row.d_inst_mytags;
                            }
                        }
                        showdata(data);
                        fnc.current.wait(false);
                    } catch (error) {
                        console.log(error);
                        fnc.current.wait(false);
                    }
               },
                onError: function (data) {
                    fnc.current.wait(false);
                    let msg = "処理に失敗しました";
                    if (!isEmpty(data.errDescription)) {
                        msg = data.errDescription;
                    }
                    fnc.current.warnmsg(msg);
                    dispatch(changestatus("VIEW"));
                }
            }
        )
    }

    function showdata(data) {
        fnc.current.margeMaster(data.master);
        entrydataRef.current = data.data;
        AcceptNo.current.no = data.data["d_inst_prodno"];
        var a = skucolRef.current;
        //行データ
        if (data.color.length !== 0) colordataRef.current = data.color;
        if (data.size.length !== 0) sizedataRef.current = data.size;
        if (data.sku.length !== 0) skudataRef.current = data.sku;
        if (data.raw1.length !== 0) raw1dataRef.current = data.raw1;
        if (data.raw2.length !== 0) raw2dataRef.current = data.raw2;
        if (data.raw3.length !== 0) raw3dataRef.current = data.raw3;
        if (data.proc.length !== 0) procdataRef.current = data.proc;
        if (data.row.length !== 0) rowdataRef.current = data.row;

        let tags = inittag;
        if (data.tag.length !== 0) {
            tags = [];
            for (let i = 0; i < data.tag.length; i++) {
                tags.push({ value: data.tag[i].d_inst_tag_no, label: data.tag[i].d_inst_tag_name });
            }
        }
        if (data.comp.length !== 0) {
            compdataRef.current = data.comp.filter(e => e.d_inst_comp_tag === '0');
            for (let i = 0; i < tags.length; i++) {
                compbytagRef.current.push({ no: tags[i].value, data: data.comp.filter(e => e.d_inst_comp_tag === tags[i].value) });
            }
        }

        if (data.wash.length !== 0) {
            for (let i = 0; i < tags.length; i++) {
                let wash = [];
                let list = data.wash.filter(e => e.d_inst_wtag_tag === tags[i].value);
                for (let j = 0; j < list.length; j++) {
                    wash.push({
                        rowid: "0",
                        mark1: list[j].d_inst_wtag_mark1, mark2: list[j].d_inst_wtag_mark2, mark3: list[j].d_inst_wtag_mark3,
                        mark4: list[j].d_inst_wtag_mark4, mark5: list[j].d_inst_wtag_mark5, mark6: list[j].d_inst_wtag_mark6,
                        mark7: list[j].d_inst_wtag_mark7
                    });
                }
                washbytagRef.current.push({ no: tags[i].value, data: wash });
                if (i === 0) {
                    washdataRef.current = wash;
                }
            }
        }
        if (data.attn.length !== 0) {
            attndataRef.current = data.attn.filter(e => e.d_inst_attn_tag === '0');
            for (let i = 0; i < tags.length; i++) {
                attnbytagRef.current.push({ no: tags[i].value, data: data.attn.filter(e => e.d_inst_attn_tag === tags[i].value) });
            }
        }
        if (data.deme.length !== 0) {
            demedataRef.current = data.deme.filter(e => e.d_inst_deme_tag === '0');
            for (let i = 0; i < tags.length; i++) {
                demebytagRef.current.push({ no: tags[i].value, data: data.deme.filter(e => e.d_inst_deme_tag === tags[i].value) });
            }
        }
        CreateSKUData(data.sku);
        imageRef.current = data.images;
        fileRef.current = data.files;
        dispatch(setimagelist(data.images));
        settaglist(tags);
        settagno("0");
    }

    function existPanel(id) {
        let pnl = panel.find(e => e.id === id);
        return pnl !== undefined;
    }
    //リストレイアウト適用
    function SetLayout(newcol, type) {
        let newfields = DeepCopy(textfields.filter(e=>e.type !==type));
        for (let i = 0; i < newcol.length; i++) {
            let column = textfieldsall.find(e => e.columnid === newcol[i]);
            newfields.push(column);
        }
        settextfields(newfields);
   }

    function showpanel(id, type, show) {
        let newpanel = DeepCopy(panel);
        let p = newpanel.find(e => e.id === id && e.type === type);
        p.hide = !show;
        setpanel(newpanel);
    }
    // スクロール位置を保存する
    function saveScrollPos() {
        scrollRef.current = EntrybodyRef.current.scrollTop;
    }
    // スクロール位置を復元する
    function restoreScrollPos() {
        try{
            if (scrollRef.current) EntrybodyRef.current.scrollTop = scrollRef.current;
        }catch{ }
    }
    //行データ保持
    function storeRowData(panel) {
        if (isEmpty(AGRef.current)) return;
        for (let i = 0; i < coldefRefs.length; i++) {
            if (panel === undefined || panel === coldefRefs[i].id) {
                let grid = coldefRefs[i].api.grid;
                coldefRefs[i].dataref.current = AGRef.current.GetDatasource(grid);
                if (coldefRefs[i].id === G_id.COMP) {
                    let ref = compbytagRef.current.find(e => e.no === tagno);
                    if (isEmpty(ref)) compbytagRef.current.push({ no: tagno, data: coldefRefs[i].dataref.current });
                    else ref.data = coldefRefs[i].dataref.current;
                }
                if (coldefRefs[i].id === G_id.WASH) {
                    let ref = washbytagRef.current.find(e => e.no === tagno);
                    if (isEmpty(ref)) washbytagRef.current.push({ no: tagno, data: coldefRefs[i].dataref.current });
                    else ref.data = coldefRefs[i].dataref.current;
                }
                if (coldefRefs[i].id === G_id.ATTN) {
                    let ref = attnbytagRef.current.find(e => e.no === tagno);
                    if (isEmpty(ref)) attnbytagRef.current.push({ no: tagno, data: coldefRefs[i].dataref.current });
                    else ref.data = coldefRefs[i].dataref.current;
                }
                if (coldefRefs[i].id === G_id.DEME) {
                    let ref = demebytagRef.current.find(e => e.no === tagno);
                    if (isEmpty(ref)) demebytagRef.current.push({ no: tagno, data: coldefRefs[i].dataref.current });
                    else ref.data = coldefRefs[i].dataref.current;
                }
            }
        }
    }

    function Jump(id, type) {
        let offset = 0;
        var panelid = "basepanel" + type;
        if (id === G_id.IMAGE) panelid = 'imagepanel';
        if (id === G_id.SKU) panelid = 'skuGrid';
        if (id === G_id.RAW1) panelid = 'raw1Grid';
        if (id === G_id.RAW2) panelid = 'raw2Grid';
        if (id === G_id.RAW3) panelid = 'raw3Grid';
        if (id === G_id.PROCESS) panelid = 'procGrid';
        if (id === G_id.COMP) panelid = 'compGrid';
        if (id === G_id.WASH) panelid = 'washGrid';
        if (id === G_id.ATTN) panelid = 'attnGrid';
        if (id === G_id.DEME) panelid = 'demeGrid';
        if (id === G_id.FILE) panelid = 'fileGrid';
        if (id === G_id.ROW) panelid = 'rowGrid';
        let elem = document.getElementById(panelid);
        if (isEmpty(elem)) return;
        offset = elem.offsetTop - 50;
        EntrybodyRef.current.scrollTop = offset;
    }

    function MenuQueryAction(action, param) {
        if (action === 'delete' && formstatus === "UPDATE") {
            if (param.tabvalue === '3') {   //SKU
                fnc.current.warnmsg("このシートのデータは削除できません");
                return false;
            }
        }
        return true;
    }
    function MenuAction(action, finallycallback, param) {
        LayoutSaveStorage();   //現在レイアウト保持
        if (action === 'save') Save(finallycallback);
        if (action === 'delete') Delete(finallycallback);
        if (action === "clear") clearform(true);
        if (action === 'linkfield') {
            if (finallycallback.table === "d_inst" || finallycallback.type === "100") {
                let type = "100";
                let col = textfields.find(e => e.columnid === finallycallback.field);
                if (col !== undefined) {
                    type = col.type;
                    let key = finallycallback.field + "_" + type;
                    document.getElementById(key).focus();
                    document.getElementById(key).select();
                }
                Jump(G_id.BASE, type);
                return;
            }
            let target = coldefRefs.find(e => e.table === finallycallback.table);
            if (isEmpty(target)) return;
            Jump(target.id);
            AGRef.current.SetRowSelect(finallycallback.rowid, finallycallback.field, target.api.grid);
        }
        if (reportsRef.current.some(e => e.id === action)) {   //帳票
            let code = [];
            if (formstatus === "ENTRY FORM") {
                code = [edittingcode];
            } else {
                for (let i = 0; i < primarykeys.length; i++) {
                    if (primarykeys[i] in param[0]) {
                        for (let j = 0; j < param.length; j++) {
                            code.push(param[j][primarykeys[i]]);
                        }
                        break;
                    }
                }
            }
            if (code.length === 0) return;
            fnc.current.postaxios('common/Printout', { controller: controller, id: action, keys: code },
                {
                    onSuccess: function (data) {
                        let params = {
                            "excelfile": data.returnData["filename"],
                            "dnfile": data.returnData["dnfile"]
                        }
                        fnc.current.filedownload("excel/ExcelDownload", params);
                        fnc.current.wait(false);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
            return;
        }
        if (action === 'datatree') {
            DataTreeOpen(edittingcode);
        }
        if (action === 'listdatatree') {
            for (let i = 0; i < primarykeys.length; i++) {
                if (primarykeys[i] in param[0]) {
                    setedittingcode(param[0][primarykeys[i]]);
                    DataTreeOpen(param[0][primarykeys[i]]);
                    return;
                }
            }
        }
        function DataTreeOpen(code) {
            fnc.current.postaxios('instruction/GetDataTree', { "code": code },
                {
                    onSuccess: function (data) {
                        fnc.current.wait(false);
                        fnc.current.datatreeopen(data.list);
                    },
                    errmsg: "処理に失敗しました"
                }
            )
        }
    }
    function Save(finallycallback) {
        var newfiles = (formstatus === "ENTRY FORM" ? [] : cfNewUploadFile(imageRef, fileRef)); //v1.4
        if (newfiles.length > 10) {
            fnc.current.warnmsg("新規登録できるアップロードファイル数は10までです。");
            return;
        }
        storeRowData();
        let comp = [];
        if (!EmptyPanel(G_id.COMP)) {
            for (let i = 0; i < taglist.length; i++) {
                let row = compbytagRef.current.find(e => e.no === taglist[i].value);
                if (taglist[i].value === tagno) row = compdataRef.current;
                if (isEmpty(row)) continue;
                for (let r = 0; r < row.length; r++) {
                    row[r]["d_inst_comp_tag"] = i;
                    comp.push(row[r]);
                }
            }
        }
        let wash = null;
        if (existPanel(G_id.WASH)) {
            wash = [];
            for (let i = 0; i < taglist.length; i++) {
                let row = washbytagRef.current.find(e => e.no === taglist[i].value);
                if (taglist[i].value === tagno) row = washdataRef.current;
                if (isEmpty(row)) continue;
                for (let r = 0; r < row.length; r++) {
                    row[r]["d_inst_wtag_tag"] = i;
                    wash.push(row[r]);
                }
            }
        }
        let attn = [];
        if (!EmptyPanel(G_id.ATTN)) {
            for (let i = 0; i < taglist.length; i++) {
                let row = attnbytagRef.current.find(e => e.no === taglist[i].value);
                if (taglist[i].value === tagno) row = attndataRef.current;
                if (isEmpty(row)) continue;
                for (let r = 0; r < row.length; r++) {
                    row[r]["d_inst_attn_tag"] = i;
                    attn.push(row[r]);
                }
            }
        }
        let deme = [];
        if (!EmptyPanel(G_id.DEME)) {
            for (let i = 0; i < taglist.length; i++) {
                let row = demebytagRef.current.find(e => e.no === taglist[i].value);
                if (taglist[i].value === tagno) row = demedataRef.current;
                if (isEmpty(row)) continue;
                for (let r = 0; r < row.length; r++) {
                    row[r]["d_inst_deme_tag"] = i;
                    deme.push(row[r]);
                }
            }
        }
        var coldef = apiRefsku.current.api.getColumnState();
        var size = [];
        if (!isEmpty(sizedataRef.current)) {
            for (let i = 0; i < sizedataRef.current.length; i++) {
                let col = coldef.find(e => e.colId === "size" + i.toString());
                if (isEmpty(col)) continue;
                if (col.hide) continue;
                sizedataRef.current[i]["index"] = i;
                size.push(sizedataRef.current[i]);
            }
        }

        const paramdata = {
            "controller": formid,
            "data": entrydataRef.current,
            "size": size,
            "sku": EmptyPanel(G_id.SKU) ? null : skudataRef.current,
            "raw1": EmptyPanel(G_id.RAW1) ? null : raw1dataRef.current,
            "raw2": EmptyPanel(G_id.RAW2) ? null : raw2dataRef.current,
            "raw3": EmptyPanel(G_id.RAW3) ? null : raw3dataRef.current,
            "proc": EmptyPanel(G_id.PROCESS) ? null : procdataRef.current,
            "tag": taglist,
            "comp": comp,
            "wash": wash,
            "attn": attn,
            "deme": deme,
            "images": imageRef.current,
            "files": fileRef.current,
            "row": EmptyPanel(G_id.ROW) ? null : rowdataRef.current,
            "colinfo": columninfo,
            "code": edittingcode
        }

        fnc.current.postaxios(formstatus === "ENTRY FORM" ? "instruction/UpdateEntry" : "instruction/InsertEntry", paramdata,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.modify(false);
                        let code = data.request;
                        if (formstatus !== "ENTRY FORM") {
                            entrydataRef.current["d_inst_code"] = data.request;
                            setedittingcode(data.request);
                            dispatch(changestatus("ENTRY FORM"));
                        }
                        if (newfiles.length !== 0) {        //v1.4
                            //新規ファイルアップロード
                            cfFileUpload("instruction", code, newfiles, fnc, () => LoadData(code));
                        } else {
                            fnc.current.success();
                            if (formstatus === "ENTRY FORM") {
                                data.data['rowid'] = Getrowid();    //更新行キー
                                finallycallback(data.data);
                            }
                            LoadData(code);     //再表示
                        }
                    }
                    else {
                        let msg = data.warning.length + "件の制約違反により登録できませんでした。";
                        fnc.current.showwarndescription(msg, data.warning);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "登録に失敗しました"
            }
        )
    }
    function Delete(finallycallback) {
        const param = {
            rowdata: [{ "rowid": edittingcode }],
            controller: controller
        }
        fnc.current.postaxios("instruction/Delete", param,
            {
                onSuccess: function (data) {
                    if (data.warning.length === 0) {
                        fnc.current.success();
                        finallycallback(edittingcode, primarykeys);
                    }
                    else {
                        fnc.current.warnmsg(["このデータは削除できません", data.warning[0].message]);
                    }
                    fnc.current.wait(false);
                },
                errmsg: "削除に失敗しました"
            }
        )
    }
    function Getrowid() {
        let data = getglobaldata("entryrowdata");
        if (isEmpty(data)) return "";
        return data.rowid;
    }
    //入力フィールドクリア
    function clearform(newform) {
        entrydataRef.current = initializedata(textfieldsall, staff);
        colordataRef.current = null;
        sizedataRef.current = null;
        skudataRef.current = null;
        raw1dataRef.current = null;
        raw2dataRef.current = null;
        raw3dataRef.current = null;
        procdataRef.current = null;
        compdataRef.current = null;
        compbytagRef.current = [];
        washdataRef.current = null;
        washbytagRef.current = [];
        attndataRef.current = null;
        attnbytagRef.current = [];
        demedataRef.current = null;
        demebytagRef.current = [];
        rowdataRef.current = null;
        imageRef.current = null;
        fileRef.current = null;
        AcceptNo.current.no = "";
        if (!isEmpty(skucolRef.current)) {
            let coldef = skucolRef.current.filter(e => e.field.indexOf('size') === -1);
            skucolRef.current = coldef;
            apiRefsku.current.grid.setGridOption('columnDefs', coldef);
        }
        scrollRef.current = null;
        dispatch(setimagelist([]));
        fnc.current.modify(false);

        if (isEnabled(newform)) {
            //SQL初期値セット
            fnc.current.postaxios("common/GetInitSqlValue", { colinfo: textfieldsall },
                {
                    onSuccess: function (data) {
                        for (let key in data.returnData) {
                            var col = textfieldsall.find(e => e.columnid === key);
                            if (!isEmpty(col)) col.initvalue = data.returnData[key];
                        }
                        entrydataRef.current = initializedata(textfieldsall, staff);
                        rerender();
                    },
                }, true
            )
        }

    }
    //基本項目設定
    function SetBaseField(type) {
        fnc.current.entrylayoutopen(type);
    }
    //レイアウト復元
    function RestoreLayout(panels, fields) {
        //パネルの並び
        RestorePanel(panels);
        //基本情報
        RestoreBase(fields)
    }
    function RestorePanel(panel) {
        let paneldata = Getstorage(corpkey, account, formid + "panel");
        if (isEmpty(paneldata)) return;
        if (panel.length !== paneldata.length) return;
        for (let i = 0; i < paneldata.length; i++) {
            let item = panel.find(e => e.id === paneldata[i].id && e.type === paneldata[i].type);
            if (isEmpty(item)) return;
            paneldata[i].name = item.name;
            paneldata[i].name2 = item.name2;
            paneldata[i].abbr = item.abbr;
        }
        setpanel(paneldata);
    }
    function RestoreBase(fields) {
        const baseinfo = Getstorage(corpkey, account, statusKey(G_id.BASE));
        if (isEmpty(baseinfo)) return;
        let newdata = [];
        for (let i = 0; i < baseinfo.length; i++) {
            let item = fields.find(e => e.table === baseinfo[i].table && e.columnid === baseinfo[i].columnid);
            if (isEmpty(item)) return;
            newdata.push(item);
        }
        settextfields(newdata);
    }
    //レイアウト保持
    function LayoutSaveStorage() {
        //列情報保存
        for (let i = 0; i < coldefRefs.length; i++) {
            AGRef.current.SaveColState(statusKey(coldefRefs[i].id), EmptyPanel(coldefRefs[i].id) ? null : coldefRefs[i].column);
        }
        //基本情報保存
        Savestorage(corpkey, account, statusKey(G_id.BASE), textfields);
        //パネルの表示/非表示および並び
        Savestorage(corpkey, account, formid + "panel", panel);
    }

    //レイアウト登録
    function SaveLayout(layoutid) {
        let setbase = false;
        let coldef = [];
        for (let p = 0; p < panel.length; p++) {
            var cols = [];
            switch (panel[p].id) {
                case G_id.BASE:
                    if (setbase) break;
                    let fds = textfields.filter(x => !x.hide);
                    for (let f = 0; f < fds.length; f++) {
                        coldef.push({
                            headerName: fds[f].columnnm, table: fds[f].table, field: fds[f].columnid, width: fds[f].width,
                            type: fds[f].type
                        });
                    }
                    setbase = true;
                    break;
                case G_id.SKU:
                    cols = AGRef.current.GetshownColDef(apiRefsku.current.column);
                    break;
                case G_id.RAW1:
                    cols = AGRef.current.GetshownColDef(apiRefraw1.current.column);
                    break;
                case G_id.RAW2:
                    cols = AGRef.current.GetshownColDef(apiRefraw2.current.column);
                    break;
                case G_id.RAW3:
                    cols = AGRef.current.GetshownColDef(apiRefraw3.current.column);
                    break;
                case G_id.PROCESS:
                    cols = AGRef.current.GetshownColDef(apiRefproc.current.column);
                    break;
                case G_id.COMP:
                    cols = AGRef.current.GetshownColDef(apiRefcomp.current.column);
                    break;
                case G_id.ATTN:
                    cols = AGRef.current.GetshownColDef(apiRefattn.current.column);
                    break;
                case G_id.DEME:
                    cols = AGRef.current.GetshownColDef(apiRefdeme.current.column);
                    break;
                case G_id.ROW:
                    cols = AGRef.current.GetshownColDef(apiRefrow.current.column);
                    break;
                default:
                    continue;
            }
            if (panel[p].id !== G_id.BASE) {
                for (let i = 0; i < cols.length; i++) {
                    let col = DeepCopy(cols[i]);
                    col.type = tabletype(panel[p].id);
                    coldef.push(col);
                }
            }
        }
        fnc.current.postaxios('common/SaveLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
                coldef: coldef,
                panels: panel
            },
            {
                onSuccess: function (data) {
                    let newlayout = { value: layoutid, label: layoutid };
                    dispatch(addentrylayout(newlayout));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト削除
    function DeleteLayout(layoutid) {
        fnc.current.postaxios('common/DeleteEntryLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    let newlayout = mainlayout.filter(function (val) { return val.value !== layoutid; });
                    dispatch(setentrylayout(newlayout));
                    if (data.request !== maininitlayout)
                        dispatch(setentrystartup({
                            prelayout: mainprelayout,
                            initlayout: " ",
                            fitColumn: false
                        }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    //レイアウト呼び出し
    function CallLayout(layoutid) {
        fnc.current.postaxios('common/LoadLayout',
            {
                controller: controller,
                subkey: subkey,
                code: layoutid,
            },
            {
                onSuccess: function (data) {
                    //列情報初期化
                    for (let i = 0; i < coldefRefs.length; i++) {
                        coldefRefs[i].ref.current = null;
                    //    var type = tabletype(coldefRefs[i].id);
                    //    var coldef = AGRef.current.createColDef(columninfo.filter(e => e.type === type), data.columns.filter(e => e.type === type), false);
                    //    if (coldefRefs[i].length === 0) continue;
                    //    coldefRefs[i].ref.current = coldef;
                    }
                    setpanel(data.panels);
                    settextfields(data.columns.filter(e => e.logpid === G_id.BASE));
                    setcolumns(data.columns);
                    fnc.current.wait(false);
                },
            }
        )
    }

    //パネル別列情報取得
    function tabletype(id) {
        let pnl = panel.find(e => e.id === id);
        if (isEmpty(pnl)) return '';
        return pnl.type;
    }

    //ケアラベル
    function caralabelAction(mode, id) {
        if (mode === 0) {
            fnc.current.formdialogopen({
                title: "ケアラベル追加", inputname: "ラベル名", dialogtype: 0,
                placeholder: "ラベル名を入力してください",
                onApply: (value)=>exec(value)
            });
            function exec(value) {
                if (taglist.find(e => e.label === value) !== undefined) {
                    fnc.current.warnmsg("同一ラベル名が存在します");
                    return;
                } else {
                    let no = value;
                    while (true) {
                        if (taglist.find(e => e.value === no) === undefined) break;
                        no += "1";
                    }
                    let newlist = taglist.concat([{
                        label: value,
                        value: no
                    }]);
                    setcarelabel(no, newlist);
                    fnc.current.formdialogclose();
                }
            }
        }
        if (mode === 1) {
            if (taglist.length === 1) {
                fnc.current.warnmsg("このケアラベルは削除できません");
                return;
            }
            fnc.current.confmsg("表示中のケアラベルを削除します。よろしいですか？", () => exec());
            function exec() {
                let data = compbytagRef.current.filter(e => e.no !== tagno);
                compbytagRef.current = data;
                data = washbytagRef.current.filter(e => e.no !== tagno);
                washbytagRef.current = data;
                data = attnbytagRef.current.filter(e => e.no !== tagno);
                attnbytagRef.current = data;
                data = demebytagRef.current.filter(e => e.no !== tagno);
                demebytagRef.current = data;
                let newlist = taglist.filter(e => e.value !== tagno);
                setcarelabel(newlist[0].value, newlist);
            }
        }
        if (mode === 2) {
            let tag = taglist.find(e => e.value === tagno);
            fnc.current.formdialogopen({
                title: "ケアラベル名の変更", inputname: "ラベル名", dialogtype: 0,
                defaultvalue: tag.label,
                placeholder: "ラベル名を入力してください",
                contents: "表示中のキー情報及びMy項目を保存します。",
                onApply: (value) => exec(value)
            });
            function exec(value) {
                if (taglist.find(e => e.label === value) !== undefined) {
                    fnc.current.warnmsg("同一ラベル名が存在します");
                    return;
                } else {
                    tag.label = value;
                    let newlist = DeepCopy(taglist);
                    setcarelabel(tagno, newlist);
                    fnc.current.formdialogclose();
               }
            }
        }
    }

    function setcarelabel(no, newlist) {
        saveScrollPos();
        storeRowData();
        if (no !== tagno) {
            compdataRef.current = null;
            washdataRef.current = null;
            attndataRef.current = null;
            demedataRef.current = null;
            //該当ケアラベルデータをセット
            let row = compbytagRef.current.find(e => e.no === no);
            if (!isEmpty(row)) compdataRef.current = row.data;
            row = washbytagRef.current.find(e => e.no === no);
            if (!isEmpty(row)) washdataRef.current = row.data;
            row = attnbytagRef.current.find(e => e.no === no);
            if (!isEmpty(row)) attndataRef.current = row.data;
            row = demebytagRef.current.find(e => e.no === no);
            if (!isEmpty(row)) demedataRef.current = row.data;
        }
        if (!isEmpty(newlist)) {
            settaglist(newlist);
        }
        if (no !== tagno) {
            settagno(no);
        }
    }

    //File Upload 再表示
    function fileuploaded(data) {
        let duplicate = false;
        if (formstatus === 'NEW FORM' || formstatus === 'COPY FORM') {  //v1.4
            if (cfMargeUploadFiles(imageRef, data.images)) duplicate = true;
            if (cfMargeUploadFiles(fileRef, data.files)) duplicate = true;
        } else {
            imageRef.current = data.images;
            fileRef.current = data.files;
        }
        dispatch(setimagelist(imageRef.current));
        rerender();
        //v1.4
        if (duplicate) fnc.current.warnmsg("同名のファイルが存在しました。差し替える場合は元のファイルを削除してからアップロードしてください");
    }

    //リストValueChange
    function ListCellChange(params, columninfo, tabvalue) {
        //簡易計算処理
        var data = null;
        var amountcalc = false;
        if (params.column.colId === "d_inst_raw_baseqty" || params.column.colId === "d_inst_raw_loss") {
            if (columninfo.some(e => e.columnid === "d_inst_raw_baseqty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_raw_qty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_raw_loss" && e.type === tabvalue)) {
                //d_inst_raw_qty＝d_inst_raw_baseqty×(1 + (d_inst_raw_loss / 100))
                let col = columninfo.find(e => e.columnid === "d_inst_raw_qty" && e.type === tabvalue);
                let qty = NumConv(params.node.data["d_inst_raw_baseqty"]) * (1 + (NumConv(params.node.data["d_inst_raw_loss"]) / 100));
                qty = GetDesitRound(qty, col.rounding, col.decimalplace);
                data = { d_inst_raw_qty: qty }
                amountcalc = true;
            }
        }
        if (params.column.colId === "d_inst_raw_rate" || params.column.colId === "d_inst_raw_currency") {
            if (columninfo.some(e => e.columnid === "d_inst_raw_rate" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_raw_currency" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_raw_price" && e.type === tabvalue)) {
                //d_inst_raw_price＝d_inst_raw_rate×d_inst_raw_currency
                if (NumConv(params.node.data["d_inst_raw_rate"]) !== 0 && NumConv(params.node.data["d_inst_raw_currency"]) !== 0) {
                    let col = columninfo.find(e => e.columnid === "d_inst_raw_price" && e.type === tabvalue);
                    let price = NumConv(params.node.data["d_inst_raw_rate"]) * NumConv(params.node.data["d_inst_raw_currency"]);
                    price = GetDesitRound(price, col.rounding, col.decimalplace);
                    if (data === null) {
                        data = { d_inst_raw_price: price }
                    } else {
                        data['d_inst_raw_price'] = price;
                    }
                    amountcalc = true;
                }
            }
        }
        if (params.column.colId === "d_inst_raw_price" || amountcalc) {
            if (columninfo.some(e => e.columnid === "d_inst_raw_price" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_raw_qty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_raw_amount" && e.type === tabvalue)) {
                //d_inst_raw_amount=d_inst_raw_qty*d_inst_raw_price
                let col = columninfo.find(e => e.columnid === "d_inst_raw_amount" && e.type === tabvalue);
                let amount = NumConv(params.node.data["d_inst_raw_qty"]) * NumConv(params.node.data["d_inst_raw_price"]);
                amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                if (data === null) {
                    data = { d_inst_raw_amount: amount }
                } else {
                    data['d_inst_raw_amount'] = amount;
                }
            }
        }
        var proccalc = false;
        if (params.column.colId === "d_inst_proc_rate" || params.column.colId === "d_inst_proc_currency") {
            if (columninfo.some(e => e.columnid === "d_inst_proc_rate" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_proc_currency" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_proc_price" && e.type === tabvalue)) {
                //d_inst_proc_price＝d_inst_proc_rate×d_inst_proc_currency
                if (NumConv(params.node.data["d_inst_proc_rate"]) !== 0 && NumConv(params.node.data["d_inst_proc_currency"]) !== 0) {
                    let col = columninfo.find(e => e.columnid === "d_inst_proc_price" && e.type === tabvalue);
                    let price = NumConv(params.node.data["d_inst_proc_rate"]) * NumConv(params.node.data["d_inst_proc_currency"]);
                    price = GetDesitRound(price, col.rounding, col.decimalplace);
                    data = { d_inst_proc_price: price }
                    proccalc = true;
                }
            }
        }
        if (params.column.colId === "d_inst_proc_price" || proccalc) {
            if (columninfo.some(e => e.columnid === "d_inst_proc_price" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_proc_qty" && e.type === tabvalue) &&
                columninfo.some(e => e.columnid === "d_inst_proc_amount" && e.type === tabvalue)) {
                //d_inst_proc_amount=d_inst_proc_qty*d_inst_proc_price
                let col = columninfo.find(e => e.columnid === "d_inst_proc_amount" && e.type === tabvalue);
                let amount = NumConv(params.node.data["d_inst_proc_qty"]) * NumConv(params.node.data["d_inst_proc_price"]);
                amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                if (data === null) {
                    data = { d_inst_proc_amount: amount }
                } else {
                    data['d_inst_proc_amount'] = amount;
                }
            }
        }
        return data;
    }

    //Grid Data Change
    function ChangeRowValue(params, id) {
        var amountcalc = false;
        if (id === G_id.RAW1 || id === G_id.RAW2 || id === G_id.RAW3) {
            if (params.column.colId === "d_inst_raw_baseqty" || params.column.colId === "d_inst_raw_loss") {
                if (columninfo.some(e => e.columnid === "d_inst_raw_baseqty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_raw_qty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_raw_loss" && e.logpid === id)) {
                    //d_inst_raw_qty＝d_inst_raw_baseqty×(1 + (d_inst_raw_loss / 100))
                    let col = columninfo.find(e => e.columnid === "d_inst_raw_qty" && e.logpid === id);
                    let qty = NumConv(params.node.data["d_inst_raw_baseqty"]) * (1 + (NumConv(params.node.data["d_inst_raw_loss"]) / 100));
                    qty = GetDesitRound(qty, col.rounding, col.decimalplace);
                    let node = params.api.getRowNode(params.node.data["rowid"]);
                    node.setDataValue("d_inst_raw_qty", qty);
                    amountcalc = true;
                }
            }
            if (params.column.colId === "d_inst_raw_rate" || params.column.colId === "d_inst_raw_currency") {
                if (columninfo.some(e => e.columnid === "d_inst_raw_rate" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_raw_currency" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_raw_price" && e.logpid === id)) {
                    //d_inst_raw_price＝d_inst_raw_rate×d_inst_raw_currency
                    if (NumConv(params.node.data["d_inst_raw_rate"]) !== 0 && NumConv(params.node.data["d_inst_raw_currency"]) !== 0) {
                        let col = columninfo.find(e => e.columnid === "d_inst_raw_price" && e.logpid === id);
                        let price = NumConv(params.node.data["d_inst_raw_rate"]) * NumConv(params.node.data["d_inst_raw_currency"]);
                        price = GetDesitRound(price, col.rounding, col.decimalplace);
                        let node = params.api.getRowNode(params.node.data["rowid"]);
                        node.setDataValue("d_inst_raw_price", price);
                        amountcalc = true;
                    }
                }
            }
            if (params.column.colId === "d_inst_raw_price" || amountcalc) {
                if (columninfo.some(e => e.columnid === "d_inst_raw_price" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_raw_qty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_raw_amount" && e.logpid === id)) {
                    //d_inst_raw_amount=d_inst_raw_qty*d_inst_raw_price
                    let col = columninfo.find(e => e.columnid === "d_inst_raw_amount" && e.logpid === id);
                    let amount = NumConv(params.node.data["d_inst_raw_qty"]) * NumConv(params.node.data["d_inst_raw_price"]);
                    amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                    let node = params.api.getRowNode(params.node.data["rowid"]);
                    node.setDataValue("d_inst_raw_amount", amount);
                }
            }
        }
        if (id === G_id.PROCESS) {
            if (params.column.colId === "d_inst_proc_rate" || params.column.colId === "d_inst_proc_currency") {
                if (columninfo.some(e => e.columnid === "d_inst_proc_rate" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_proc_currency" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_proc_price" && e.logpid === id)) {
                    //d_inst_proc_price＝d_inst_proc_rate×d_inst_proc_currency
                    if (NumConv(params.node.data["d_inst_proc_rate"]) !== 0 && NumConv(params.node.data["d_inst_proc_currency"]) !== 0) {
                        let col = columninfo.find(e => e.columnid === "d_inst_proc_price" && e.logpid === id);
                        let price = NumConv(params.node.data["d_inst_proc_rate"]) * NumConv(params.node.data["d_inst_proc_currency"]);
                        price = GetDesitRound(price, col.rounding, col.decimalplace);
                        let node = params.api.getRowNode(params.node.data["rowid"]);
                        node.setDataValue("d_inst_proc_price", price);
                        amountcalc = true;
                    }
                }
            }
            if (params.column.colId === "d_inst_proc_price" || amountcalc) {
                if (columninfo.some(e => e.columnid === "d_inst_proc_price" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_proc_qty" && e.logpid === id) &&
                    columninfo.some(e => e.columnid === "d_inst_proc_amount" && e.logpid === id)) {
                    //d_inst_proc_amount=d_inst_proc_qty*d_inst_proc_price
                    let col = columninfo.find(e => e.columnid === "d_inst_proc_amount" && e.logpid === id);
                    let amount = NumConv(params.node.data["d_inst_proc_qty"]) * NumConv(params.node.data["d_inst_proc_price"]);
                    amount = GetDesitRound(amount, col.rounding, col.decimalplace);
                    let node = params.api.getRowNode(params.node.data["rowid"]);
                    node.setDataValue("d_inst_proc_amount", amount);
                }
            }
        }
        storeRowData(id);
    }

    //Basic Data Change
    function ValueChanged(id, value) {
        if (id === "d_inst_prodno") {   //製品コード
            if (value === AcceptNo.current.no) return;
            if (isEmpty(value)) {
                entrydataRef.current["d_inst_prodno"] = AcceptNo.current.no;
                fnc.current.entryrerender();
                return;
            }
            AcceptAction(value);
        }
        //外部からの参照がある項目
        let col = columninfo.find(e => e.columnid === id);
        if (!isEmpty(col)) {
            if (col.extriggerref) {
                dispatch(entrytriggercall(id));
            }
        }
    }

    //受入処理
    function AcceptAction(value) {
        fnc.current.postaxios('instruction/GetAccept', { "code": value, "colinfo": columninfo },
            {
                onSuccess: function (data) {
                    clearform();
                    showdata(data);

                    fnc.current.closewarnning();
                    rerender();
                    fnc.current.wait(false);
                },
                onError: function (data) {
                    //受入番号を元に戻す
                    entrydataRef.current["d_init_prodno"] = AcceptNo.current.no;
                    fnc.current.entryrerender();
                    fnc.current.warnmsg("入力された製品コードは存在しません");
                    fnc.current.wait(false);
                },
                errmsg: "処理に失敗しました"
            }
        )
    }

    function SkuValueChange(param) {
        if (isEmpty(param.colDef)) return;
        if (param.colDef.field === "colorcd" || param.colDef.field === "colornm") return;
        if (param.colDef.field === "cancel" && param.value === "1") {
            //除外ONの場合数量クリア
            for (let i = 0; i < sizedataRef.current.length; i++) {
                param.data["size" + i.toString()] = '';
            }
            param.node.setData(param.data);
        }
        if (param.colDef.field !== "cancel") {
            if (NumConv(param.value) !== 0 && param.data["cancel"] === "1") {
                param.node.setDataValue("cancel", "0");
            }
        }
        SetTotalQty();
        storeRowData(G_id.SKU);
    }
    function SizeVisible(param) {
        if (param.visible) return;
        //非表示にした場合数量クリア
        apiRefsku.current.grid.forEachNode((rowNode, index) => {
            rowNode.setDataValue(param.column.colId, "");
        });
        SetTotalQty();
    }
    function SetTotalQty() {
        let total = 0;
        apiRefsku.current.grid.forEachNode((rowNode, index) => {
            for (let i = 0; i < sizedataRef.current.length; i++) {
                if (!isEmpty(rowNode.data['size' + i.toString()])) {
                    let qty = NumConv(rowNode.data['size' + i.toString()]);
                    total += parseInt(qty);
                }
            }
        });
        let entrydata = entrydataRef.current;
        if (entrydata === null) entrydata = { "d_inst_qty": total};
        else entrydata["d_inst_qty"] = total;
        entrydataRef.current = entrydata;
        fnc.current.entryrerender();
    }
    //リスト編集セル制御
    function ListlockCell(params, edit, status, tabvalue) {
        if (status === "INSERT") {
            if (params.colDef.field === "d_inst_mytags" ||
                params.colDef.field === "d_inst_sharetags" ||
                params.colDef.field === "d_inst_sticky" ||
                params.colDef.field === "d_inst_memo") {
                return false;
            }
        }
        if (!edit) return edit;
        if (status === "UPDATE") {
            if (params.colDef.field === "d_inst_prodno") return false;
        }
        return edit;
    }

    //明細カラム定義
    function ColdefSpecial(column) {
        //「除外」列にフィルタを追加
        if (column.field === "cancel") {
            column.menuTabs = ['filterMenuTab', 'generalMenuTab'];
        }
    }
    function CreateSKUData(data) {
        //SKU明細定義追加
        let coldef = skucolRef.current.filter(e => e.field.indexOf('size') === -1);
        let cols = [
            {columnid: 'cancel', columnnm: '除外', datatype: "13", type: "103", logpid: G_id.SKU },
            { columnid: 'colorcd', columnnm: 'C/#', datatype: "0", type: "103", logpid: G_id.SKU, locked: true },
            { columnid: 'colornm', columnnm: 'カラー', datatype: "0", type: "103", logpid: G_id.SKU, locked: true }
        ];
        if (!isEmpty(sizedataRef.current)) {
        for (let i = 0; i < sizedataRef.current.length; i++) {
            let size = sizedataRef.current[i];
            let col = {
                columnid: 'size' + i.toString(),
                columnnm: size['d_inst_size_no'] + ":" + size['d_prod_size_name'],
                datatype: "1", logpid: G_id.SKU, formula:'', decimalplace:0
            }
            cols.push(col);
            coldef.push(
                {
                    field: 'size' + i.toString(), colId: 'size' + i.toString(),
                    headerName: size['d_inst_size_no'] + ":" + size['d_prod_size_name'],
                    width: 80, editable: true, datatype: '1',
                    hide: size['d_inst_size_cancel'] === '1',
                    cellClass: 'ag-right-aligned-cell',
                    colinfo:col
                });
            }
        }
        skucolRef.current = coldef;
        apiRefsku.current.grid.setGridOption('columnDefs', coldef);
        let newcolinfo = columninfo.filter(e => e.logpid !== G_id.SKU);
        newcolinfo = [...newcolinfo, ...cols];
        setcolumninfo(newcolinfo);
        newcolinfo = columns.filter(e => e.logpid !== G_id.SKU);
        newcolinfo = [...newcolinfo, ...cols];
        setcolumns(newcolinfo);
        let newdata = [];
        if (!isEmpty(colordataRef.current)) {
            for (let i = 0; i < colordataRef.current.length; i++) {
                let color = colordataRef.current[i];
                var row = {'rowid':'rowid' + i.toString(), 'cancel': color['d_inst_color_cancel'], 'colorcd': color['d_inst_color_no'], 'colornm':color['d_prod_color_name']};
                for (let j = 0; j < sizedataRef.current.length; j++) {
                    let size = sizedataRef.current[j];
                    let qty = data.find(e => e.d_inst_sku_color === color['d_inst_color_no'] && e.d_inst_sku_size === size['d_inst_size_no']);
                    if (!isEmpty(qty)) {
                        row['size' + j.toString()] = qty['d_inst_sku_qty'];
                    }
                }
                newdata.push(row);
            }
        }
        skudataRef.current = newdata;

    }

    //panel入れ替え
    const onPanelSortEnd = ({ oldIndex, newIndex }) => {
        let items = panel.filter(e => !panelhidden(e));
        let oldidx = panel.findIndex(e => e.type === items[oldIndex].type);
        let newidx = panel.findIndex(e => e.type === items[newIndex].type);
        setpanel(arrayMove(panel, oldidx, newidx));
    };


    //パネルセレクタ
    function panelnavwidth() {
        return windowDimensions.width - 280;
    }
    const SortablePanelItem = SortableElement(({ pnl }) => (
        <ListItem className="minwidth0">
            <Chip
                label={pnl.abbr}
                title={pnl.name}
                size="small"
                onClick={() => Jump(pnl.id, pnl.type)}
            />
        </ListItem>
    ));
    const SortablePanelSelector = SortableContainer(({ items }) => {
        var newitem = [];
        for (let i = 0; i < items.length; i++) {
            if (!panelhidden(items[i])) newitem.push(items[i]);
        }
        return (
            <ul style={{ display: 'flex' }}  >
                {newitem.map((value, index) => (
                    <SortablePanelItem key={`item-${index}`} index={index} pnl={value} disabled={layoutlock} />
                ))}
            </ul>
        );
    });

    function Contents(props) {
        if (props.panel.id === "0") {
            const baseid = "basepanel" + props.panel.type;
            return (
                <div id={baseid} >
                    <EntryBase
                        fnc={fnc}
                        textfields={textfields}
                        settextfields={settextfields}
                        panel={props.panel}
                        ValueChanged={ValueChanged}
                        entrydataRef={entrydataRef}
                        layoutlock={layoutlock}
                    />
                </div>
            );
        }
        if (props.panel.id === G_id.IMAGE) {
            return (
                <EntryImages
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={imageRef}
                    rerender={rerender}
                />
            )
        }
        if (props.panel.id === G_id.SKU) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="skuGrid"
                    dataRef={skudataRef}
                    columnRef={skucolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.SKU)}
                    rowDrag={false}
                    rowContext={false}
                    AutoAddRow={false}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.SKU)}
                    ValueChanged={SkuValueChange}
                    ColumnVisible={SizeVisible}
                    RowValueChanged={() => storeRowData(G_id.SKU)}
                    RemoveRow={() => storeRowData(G_id.SKU)}
                    ColdefSpecial={ColdefSpecial}
                />
            );
        }
        if (props.panel.id === G_id.RAW1) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="raw1Grid"
                    dataRef={raw1dataRef}
                    columnRef={raw1colRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.RAW1)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.RAW1)}
                    ValueChanged={(e) => ChangeRowValue(e, G_id.RAW1)}
                    RowValueChanged={() => storeRowData(G_id.RAW1)}
                    RemoveRow={() => storeRowData(G_id.RAW1)}
                />
            );
        }
        if (props.panel.id === G_id.RAW2) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="raw2Grid"
                    dataRef={raw2dataRef}
                    columnRef={raw2colRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.RAW2)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.RAW2)}
                    ValueChanged={(e) => ChangeRowValue(e, G_id.RAW2)}
                    RowValueChanged={() => storeRowData(G_id.RAW2)}
                    RemoveRow={() => storeRowData(G_id.RAW2)}
               />
            );
        }
        if (props.panel.id === G_id.RAW3) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="raw3Grid"
                    dataRef={raw3dataRef}
                    columnRef={raw3colRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.RAW3)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.RAW3)}
                    ValueChanged={(e) => ChangeRowValue(e, G_id.RAW3)}
                    RowValueChanged={() => storeRowData(G_id.RAW3)}
                    RemoveRow={() => storeRowData(G_id.RAW3)}
                />
            );
        }
        if (props.panel.id === G_id.PROCESS) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="procGrid"
                    dataRef={procdataRef}
                    columnRef={proccolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.PROCESS)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.PROCESS)}
                    ValueChanged={(e) => ChangeRowValue(e, G_id.PROCESS)}
                    RowValueChanged={() => storeRowData(G_id.PROCESS)}
                    RemoveRow={() => storeRowData(G_id.PROCESS)}
                />
            );
        }
        if (props.panel.id === G_id.COMP) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="compGrid"
                    dataRef={compdataRef}
                    columnRef={compcolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.COMP)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.COMP)}
                    ValueChanged={() => storeRowData(G_id.COMP)}
                    RowValueChanged={() => storeRowData(G_id.COMP)}
                    RemoveRow={() => storeRowData(G_id.COMP)}
                />
            );
        }
        if (props.panel.id === G_id.WASH) {
            return (
                <WashGrid
                    id={props.panel.id}
                    elemid="washGrid"
                    table="d_inst_wash"
                    dataRef={washdataRef}
                    columnRef={washcolRef}
                    type={tabletype(G_id.COMP)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    ValueChanged={() => storeRowData(G_id.WASH)}
                    RowValueChanged={() => storeRowData(G_id.WASH)}
                    RemoveRow={() => storeRowData(G_id.WASH)}
                />
            );
        }
        if (props.panel.id === G_id.ATTN) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="attnGrid"
                    dataRef={attndataRef}
                    columnRef={attncolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.ATTN)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.ATTN)}
                    ValueChanged={() => storeRowData(G_id.ATTN)}
                    RowValueChanged={() => storeRowData(G_id.ATTN)}
                    RemoveRow={() => storeRowData(G_id.ATTN)}
                />
            );
        }
        if (props.panel.id === G_id.DEME) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="demeGrid"
                    dataRef={demedataRef}
                    columnRef={demecolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.DEME)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.DEME)}
                    ValueChanged={() => storeRowData(G_id.DEME)}
                    RowValueChanged={() => storeRowData(G_id.DEME)}
                    RemoveRow={() => storeRowData(G_id.DEME)}
                />
            );
        }
        if (props.panel.id === G_id.ROW) {
            return (
                <EntryGrid
                    id={props.panel.id}
                    elemid="rowGrid"
                    dataRef={rowdataRef}
                    columnRef={rowcolRef}
                    columninfo={columninfo}
                    columns={columns}
                    type={tabletype(G_id.ROW)}
                    fnc={fnc}
                    onGridReady={onGridReady}
                    onFirstDataRendered={onFirstDataRendered}
                    statusKey={statusKey(G_id.ROW)}
                    ValueChanged={() => storeRowData(G_id.ROW)}
                    RowValueChanged={() => storeRowData(G_id.ROW)}
                    RemoveRow={() => storeRowData(G_id.ROW)}
                />
            );
        }
        if (props.panel.id === G_id.FILE) {
            return (
                <EntryFiles
                    fnc={fnc}
                    controller={controller}
                    code={edittingcode}
                    dataRef={fileRef}
                    rerender={rerender}
                />
            )
        }
        return null;

    }
    function EmptyPanel(id, type) {
        try {
            if (!panel.some(e => e.id === id)) return true; //パネル定義なし
            if (!isEmpty(type)) {
                if (!panel.some(e => e.id === id && e.type === type)) return true; //パネル定義なし
            }
            if (id === G_id.BASE)  return isEmpty(textfields.find(e => e.type === type));
            if (id === G_id.WASH) return false;
            let tbltype = tabletype(id);
            return !columns.some(e => e.type === tbltype);
        } catch { }
        return false;
    }
    function panelhidden(p) {
        if (isEmpty(p)) return false;
        if ((p.id === G_id.IMAGE && imagelist.length === 0) || (p.id === G_id.FILE && files.length === 0)) return true;
        if (EmptyPanel(p.id, p.type)) return true;
        return p.hide;
    }

    function EntryForm() {
        return (
            <div style={{ padding: '5px 15px', paddingBottom: '300px', height: '100%', overflow: 'auto', backgroundColor: '#D8D8D8' }} ref={EntrybodyRef} onDragEnter={onDragEnter}>
                {panel.map((p,i) => {
                   return (
                        <Box
                           display={panelhidden(p) ? "none" : "flex"}
                           justifyContent="space-around"
                           alignItems="center"
                           padding="5px"
                            >
                            <Paper
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    padding: 10
                                }}
                           >
                               <div style={{ position: 'relative', marginBottom: 5 }}>
                                   {p.name} - <span style={{ fontStyle: 'oblique' }}>{p.name2}</span>
                                   {p.id !== '0' || layoutlock ? null :
                                       <div style={{ position: 'absolute', right: 40, top: -3 }} title="項目設定">
                                           <IconButton size="small" onClick={()=>SetBaseField(p.type)}  >
                                               <Icon style={{ fontSize: 16 }}>settings_applications</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {layoutlock || sectionclose? null :
                                       <div style={{ position: 'absolute', right: 10, top: -3 }}>
                                           <IconButton size="small" onClick={() => showpanel(p.id, p.type, false)}  >
                                               <Icon style={{ fontSize: 16 }}>close</Icon>
                                           </IconButton>
                                       </div>
                                   }
                                   {p.id === G_id.COMP || p.id === G_id.WASH || p.id === G_id.ATTN || p.id === G_id.DEME ?
                                       <div style={{ position: 'absolute', left: 200, top: 0 }}>
                                        <TextField
                                            id={"carelabel_" + p.id}
                                            select
                                            hiddenLabel
                                            value={tagno}
                                               onChange={(e) => setcarelabel(e.target.value)}
                                            variant="standard"
                                            size="small"
                                            style={{ width: 150 }}
                                            inputProps={{ style: { fontSize: 12 } }} 
                                        >
                                          {taglist.map((option) => (
                                            <MenuItem key={option.value} value={option.value} style={{ fontSize: 12 }}>
                                              {option.label}
                                            </MenuItem>
                                          ))}
                                           </TextField>
                                           {entrylock ? null :
                                               <React.Fragment>
                                                <IconButton size="small" onClick={() => caralabelAction(0, p.id)} title="ケアラベル追加">
                                                    <Icon style={{ fontSize: 16 }}>add_box</Icon>
                                               </IconButton>
                                               <IconButton size="small" onClick={() => caralabelAction(1, p.id)} title="ケアラベル削除">
                                                    <Icon style={{ fontSize: 16 }}>indeterminate_check_box</Icon>
                                                </IconButton>
                                               <IconButton size="small" onClick={() => caralabelAction(2, p.id)} title="名前の変更">
                                                    <Icon style={{ fontSize: 16 }}>drive_file_rename_outline</Icon>
                                                </IconButton>
                                               </React.Fragment>
                                            }
                                       </div>
                                        : null
                                   }
                               </div>
                                    <Contents panel={p}/>
                                </Paper >
                           </Box>
                    );
                })}
            </div>
        );
    }
    return (
        <div>
            <ComFunc ref={fnc} />
            <MasterBase
                formid={formid}
                controller={controller}
                subkey={subkey}
                location={props.location}
                actionurl={actionurl}
                uploaded={fileuploaded}
                entrycallback={MenuAction}
                queryaction={MenuQueryAction}
                condition={true}
                entryform={true}
                tabs={true}
                show={Show}
                primaryid={'d_inst'}
                primarykey={primarykeys}
                navmenu={entrylock ? navmenu.filter(e => e.menuid !== 'formupload') : navmenu}
                listcellchange={ListCellChange}
                suppressaction={suppressaction}
                lockcell={ListlockCell}
                masonry={true}
            >
            <EntryForm/>
            </MasterBase>
            <EntryLayout
                 columninfo={textfieldsall}
                 textfields={textfields} 
                 onAppry={SetLayout}
            />
            {formstatus === 'NEW FORM' || formstatus === 'ENTRY FORM' || formstatus === 'COPY FORM' ?
                <div>
                    <div style={{ position: 'absolute', top: 60, right: 15 }}>
                        <IconButton size="small" onClick={()=>fnc.current.entrysettingopen()} title={"レイアウト設定"} >
                            <Icon>table_chart</Icon>
                        </IconButton>
                    </div>
                    <Headline columninfo={columninfo} entrydata={entrydataRef.current} ></Headline>
                    <div style={{ position: 'absolute', top: 60, left: 210}}>
                    <Paper
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            flexWrap: 'wrap',
                            listStyle: 'none',
                            p: 0.2,
                            m: 0,
                        }}
                        component="ul"
                            elevation={0}
                            style={{ backgroundColor: "transparent", width: panelnavwidth() }}
                    >
                            {/*Panel Selector*/}
                            <SortablePanelSelector
                                axis={"x"}
                                items={panel}
                                onSortEnd={onPanelSortEnd}
                                distance={2}
                             />
                    </Paper>
                    </div>
                </div>
                : null}
            <AGFunc ref={AGRef} />
            <EntrySetting
                formid={formid}
                controller={controller}
                subkey={subkey}
                savelayout={SaveLayout}
                deletelayout={DeleteLayout}
                calllayout={CallLayout}
                panels={panel}
                showpanel={showpanel}
            />
            <DataTree code={edittingcode} />
            <DropZone
                code={edittingcode}
                open={isDragActive}
                onclose={FileDropClose}
                actionurl={actionurl}
                uploaded={fileuploaded}
            />
        </div>
    );
};

